const WorkPreferenceFormNames = {
  CurrentSituation: 'work-preference-current-situation-form',
  DesiredProject: 'work-preference-desired-project-form',
  Skills: 'work-preference-skills-form',
  Others: 'work-preference-others-form'
} as const

export { WorkPreferenceFormNames }
